import { connect } from 'react-redux'
import WorkshiftFormComponent from '../../../components/employer/workshifts/workshiftForm.component'
import {
  addWorkshifts,
  updateWorkshift,
  cancelEditWorkShift,
  closeWorkshiftFormDialog
} from '../../../actions/employer'

const mapStateToProps = (state) => {
  return {
    state,
    isEditWorkshift: state.workshifts.isEditWorkshift,
    emailSelectionList: state.workshifts.emailSelectionList,
    allWaitingForConfirmation: state.workshifts.allWaitingForConfirmation
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    addWorkshifts: (formValues, selectedOfferTo) =>
      dispatch(addWorkshifts(formValues, selectedOfferTo)),
    updateWorkshift: (formValues) => dispatch(updateWorkshift(formValues)),
    cancelEditWorkShift: () => dispatch(cancelEditWorkShift()),
    closeWorkshiftFormDialog: () => dispatch(closeWorkshiftFormDialog())
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps)

const WorkshiftFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(WorkshiftFormComponent)

export default WorkshiftFormContainer
